// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import cognito from './cognito';

Vue.config.productionTip = false

router.beforeResolve(async (to, from, next) => {
  try {
    const session = await cognito.isAuthenticated();
    const token = session.idToken.jwtToken;

    if (to.matched.some(r => r.meta.notRequiredAuth)) {
      next({
        path: '/',
      });
    }
  } catch (e) {
    if (to.matched.some(r => r.meta.requiredAuth)) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath },
      });
    }
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  cognito,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js